// src/router/modules/partner.js
import Layout from '@/layout';
var partnerRouter = {
  path: '/partner',
  component: Layout,
  redirect: '/partner/dashboard',
  name: 'Partner',
  meta: {
    title: '合伙人',
    icon: 'clipboard'
  },
  children: [{
    path: 'dashboard',
    component: function component() {
      return import('@/views/partner/dashboard/index');
    },
    name: 'PartnerDashboard',
    meta: {
      title: '合伙人仪表盘',
      icon: ''
    }
  }, {
    path: 'index',
    component: function component() {
      return import('@/views/partner/index');
    },
    name: 'PartnerIndex',
    meta: {
      title: '合伙人列表',
      icon: ''
    }
  }, {
    path: 'product',
    component: function component() {
      return import('@/views/partner/product');
    },
    name: 'PartnerProduct',
    meta: {
      title: '选品中心',
      icon: ''
    }
  }, {
    path: 'delivery',
    component: function component() {
      return import('@/views/partner/factory');
    },
    name: 'PartnerFactoryDelivery',
    meta: {
      title: '物流工厂',
      icon: ''
    }
  }, {
    path: 'order',
    component: function component() {
      return import('@/views/partner/order/index');
    },
    name: 'PartnerOrder',
    meta: {
      title: '订单管理',
      icon: ''
    }
  }, {
    path: 'learn',
    component: function component() {
      return import('@/views/partner/learn/index');
    },
    name: 'PartnerLearn',
    meta: {
      title: '学习管理',
      icon: ''
    },
    children: [{
      path: 'learn',
      component: function component() {
        return import('@/views/partner/learn/learn');
      },
      name: 'PartnerLearnLearn',
      meta: {
        title: '营销课程',
        icon: ''
      }
    }, {
      path: 'learnDetail',
      component: function component() {
        return import('@/views/partner/learn/learnDetail');
      },
      name: 'PartnerLearnLearnDetail',
      meta: {
        title: '营销课程详情',
        icon: '',
        activeMenu: "/partner/learn/learn"
      }
    }, {
      path: 'teacher',
      component: function component() {
        return import('@/views/partner/learn/teacher');
      },
      name: 'PartnerLearnTeacher',
      meta: {
        title: '培训讲师',
        icon: ''
      }
    }, {
      path: 'down',
      component: function component() {
        return import('@/views/partner/learn/down');
      },
      name: 'PartnerLearnDown',
      meta: {
        title: '营销文库',
        icon: ''
      }
    }, {
      path: 'downCate',
      component: function component() {
        return import('@/views/partner/learn/downCate');
      },
      name: 'PartnerLearnDownCate',
      meta: {
        title: '营销文库分类',
        icon: ''
      }
    }]
  }, {
    path: 'note',
    component: function component() {
      return import('@/views/partner/note/index');
    },
    name: 'PartnerNote',
    meta: {
      title: '协议公告',
      icon: ''
    },
    children: [{
      path: 'notice',
      component: function component() {
        return import('@/views/partner/note/notice');
      },
      name: 'PartnerNoteNotice',
      meta: {
        title: '公告管理',
        icon: ''
      }
    }, {
      path: 'argee',
      component: function component() {
        return import('@/views/partner/note/argee');
      },
      name: 'PartnerNoteArgee',
      meta: {
        title: '协议管理',
        icon: ''
      }
    }, {
      path: 'msg',
      component: function component() {
        return import('@/views/partner/note/msg');
      },
      name: 'PartnerNoteMsg',
      meta: {
        title: '意见反馈',
        icon: ''
      }
    }, {
      path: 'adv',
      component: function component() {
        return import('@/views/partner/note/adv');
      },
      name: 'PartnerNoteAdv',
      meta: {
        title: '广告管理',
        icon: ''
      }
    }]
  }]
};
export default partnerRouter;